// ddb = desaturated dark blue
// lgo = light grayish orange
// vdgb = very dark grayish blue

const themeOne = {
    backgrounds: {
        main: 'hsl(222, 26%, 31%)',
        toggle: 'hsl(223, 31%, 20%)',
        keypad: 'hsl(223, 31%, 20%)',
        screen: 'hsl(224, 36%, 15%)'
    },

    keys: {
        'ddb-bg': 'hsl(225, 21%, 49%)',
        'ddb-shadow': 'hsl(224, 28%, 35%)',
        'red-bg-toggle': 'hsl(6, 63%, 50%)',
        'dark-red-shadow': 'hsl(6, 70%, 34%)',
        'lgo-bg': 'hsl(30, 25%, 89%)',
        'grayish-orange-shadow': 'hsl(28, 16%, 65%)'
    },

    text: {
        vdgb: 'hsl(221, 14%, 31%)',
        white: 'hsl(0, 0%, 100%)'
    }
};

export default themeOne;
